import React from "react";
import cn from "classnames";

const PrimaryButton = ({ type, onClick, text, className, disabled }) => {
  return (
    <button
      disabled={disabled}
      type={type ? type : "button"}
      onClick={onClick ? onClick : () => {}}
      className={cn(
        "w-full px-4 py-2 bg-baseBlue text-white font-medium rounded-lg hover:bg-mediumBlue transition-colors duration-300",
        className
      )}
    >
      {text}
    </button>
  );
};

export default PrimaryButton;
